import type React from 'react'
import { cn } from '../../../../shared/cn'
import { applyPolishOrphans } from '../../../../shared/preventPolishOrphans'

export function H1({ className, children, ...props }: React.ComponentPropsWithoutRef<'h1'>) {
  return (
    <h1 {...props} className={cn('font-bold text-3xl lg:font-extrabold lg:text-5xl', className)}>
      {applyPolishOrphans(children)}
    </h1>
  )
}
